<template>
  <v-card>
    <v-card-title>
      {{ fund.precheck ? $t("user.precheck.success.title") : $t("user.minimal.success.title") }}
    </v-card-title>

    <v-card-text>
      {{ fund.precheck ? $t("user.precheck.success.text") : $t("user.minimal.success.text") }}
    </v-card-text>

    <v-card-actions>
      <v-btn color="primary" :to="{ name: 'home' }">
        {{ fund.precheck ? $t("user.precheck.success.cta") : $t("user.minimal.success.cta") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    fund: {
      type: Object,
      required: true,
    },
  },
};
</script>
